import contentDisposition from "content-disposition";

export const SAVE_ACTION_TYPE = {
  SAVE_TO_FILE: "download",
  OPEN_NEW_TAB: "openDocument"
}

export const saveResponse = (response, saveActionType) => {
  const fileType = response.headers["content-type"];
  const defaultFileName = "document-" + Math.floor(Date.now() / 1000);
  let contentFileName;
  const header = response.headers["content-disposition"];
  if (header) {
    contentFileName = contentDisposition.parse(header).parameters.filename;
  }
  if (saveActionType == SAVE_ACTION_TYPE.SAVE_TO_FILE) {
    saveByteArray(contentFileName || defaultFileName, response.data, fileType);
  } else if (saveActionType == SAVE_ACTION_TYPE.OPEN_NEW_TAB) {
    openInNewTab(contentFileName || defaultFileName, response.data, fileType);
  }
};

export const openInNewTab = (fileName, bytes, type) => {
  const blob = new Blob([bytes], { type: type });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.target = "_blank"
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const saveByteArray = (fileName, bytes, type) => {
  const blob = new Blob([bytes], { type: type });
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const convertBase64ToBlob = (base64Image) => {
  const parts = base64Image.split(";base64,");
  const imageType = parts[0].split(":")[1];
  const decodedData = window.atob(parts[1]);
  const uInt8Array = new Uint8Array(decodedData.length);

  for (let i = 0; i < decodedData.length; ++i) {
    uInt8Array[i] = decodedData.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: imageType });
};
